module.exports = __webpack_public_path__ + "img/kh3@2x.48b94a12.png";